module.exports = __webpack_public_path__ + "media/images/story/top/enimari-96ec9b7edfb91a7503fcfd884163a069.svg";